._container_t2d0j_1 {
  display: flex;
  width: 720px; }

._contentContainer_t2d0j_5 {
  display: flex;
  width: 100%; }
